import { createFileRoute } from '@tanstack/react-router'

import { RoleGate } from '@/components/guards'
import { BusinessSettingsPage } from '@/pages/settings/organization/BusinessSettingsPage'

export const Route = createFileRoute('/_authenticated/_dashboard/settings/organization/')(
  {
    component: RouteComponent,
  },
)

function RouteComponent() {
  return (
    <RoleGate requires="ADMIN">
      <BusinessSettingsPage />
    </RoleGate>
  )
}
